import type IWorkspaceMetadataStore from "@/common/services/Workspace/IWorkspaceMetadataStore";
import { defineStore } from "pinia";

export const WorkspaceMetadataStore = defineStore('WorkspaceMetadataStore', {
  actions: {
    removeErrors() {
      this.notification.messages = this.notification.messages
          .filter((notification) => notification.type !== "ERROR")
    },
    removeNotifications() {
      this.notification.messages =[];
    }
  },
  state: (): IWorkspaceMetadataStore => ({
    languageConstants: {},
    error: {
      errorMessage: "",
      eodError: ""
    },
    themes: {
      themes: []
    },
    plaidlinktoken: "",
    receivedredirecturi: "",
    messages: {},
    serviceUrls: {},
    onErrorRedirectTo: "",
    coreCredentials: {
      coreLogin: null,
      corePassword: null
    },
    isExistingSignature: false,
    signatureFormTitle: "",
    signatureBase64: "",
    forceInterceptor: false,
    ignoreInterceptor: false,
    toast: {
      showToast: false,
      message: "",
      icon: "",
      type: ""
    },
    notification: {
      messages: [],
      useLocalNotificationLocks: new Set(),
    },
    dialogOptions: {},
    wizardProps: {
      continue: undefined,
      continueDisabled: false,
      back: undefined,
      continueReplacedWithSecondary: false,
      alternateBackEnabled: false,
      alternateBackText: "",
      alternateBackFunc: undefined,
      backDisabled: false,
      disabled: false,
      secondaryAction: undefined,
      secondaryActionText: "",
      secondaryActionActive: undefined,
      secondaryActionClass: "",
      continueDisabledSecondary: false,
      loading: false,
      loaderMessages: undefined,
      hideInfoBlock: false,
      hideNavigation: false,
      bltUiText: "",
      hideProgressbar: false,
      hideBackButton: false,
      hideContinueButton: false,
      showDeterminateProgressBar: false,
      searchIcon: false,
      innerScreenButtonEnabled: false,
      innerScreenBtnFunc: undefined,
      contentCardClass: "",
      dividerLine: false,
      hideTitle: false,
      contentMarginClass: "",
      hideErrorNotification: false
    },
    baseUrl: "",
  })
});
